import { useState, useEffect } from 'react';
import parse from 'html-react-parser';
import WarningIcon from '@/customercenter-ui/svgs/notifications/warning';
import { mapLocaleToMeaningfulFormat } from '@/helpers/utils/i18n';
import { getCookieValue } from '@/helpers/utils/siteUtils';
import { BRAND_TEXT_TO_REPLACE, COOKIE_KEYS } from '../../../../../../constants/constant';
import { getContentByTitle } from '../../../../../customercenter-ui/components/product/details/helpers/utils/productDataUtils';

const OrderApprovalPendingMessage = ({ order }: any) => {
  return (
    <section className="w-full md:max-w-[1141px]">
      <p className="pt-8 text-2xl font-bold text-black">
        {mapLocaleToMeaningfulFormat().orderPendingApprovalTitle} &nbsp;
        {mapLocaleToMeaningfulFormat().orderHash}
        {order?.orderNumber}
      </p>
    </section>
  );
};

const OrderPendingApprovalBox = () => {
  const [orderPendingCreditApproval, setOrderPendingCreditApproval] = useState('');
  const [orderPendingCreditMessage, setOrderPendingCreditMessage] = useState('');
  const [currentSite, setCurrentSite] = useState<string>('ZBSite');
  const curentSiteName = currentSite && (mapLocaleToMeaningfulFormat() as { [key: string]: any })[currentSite];

  useEffect(() => {
    const cookieSiteId = getCookieValue(COOKIE_KEYS.selectedSite) ?? 'ZBSite';
    setCurrentSite(cookieSiteId);
  }, []);

  useEffect(() => {
    getContentByTitle('orderPendingCreditApproval').then((data: any) => {
      setOrderPendingCreditApproval(data?.htmlContentEntries?.[0]?.rich_text_and_html_editor || '');
    });
    getContentByTitle('orderPendingCreditMessage').then((data: any) => {
      setOrderPendingCreditMessage(data?.htmlContentEntries?.[0]?.rich_text_and_html_editor || '');
    });
  }, []);

  return (
    <section className="rounded-sm bg-[#FFF4E6] p-5 shadow-md lg:mx-0">
      <section className="flex items-center pb-3 ">
        <section className="pr-3">
          <WarningIcon className="h-6 w-7" />
        </section>

        <p className="text-xl font-medium leading-7 text-black">{parse(orderPendingCreditApproval)}</p>
      </section>

      <p className="text-sm font-medium text-black">
        {parse(orderPendingCreditMessage?.replaceAll(BRAND_TEXT_TO_REPLACE, curentSiteName))}
      </p>
    </section>
  );
};

export { OrderApprovalPendingMessage, OrderPendingApprovalBox };
